/**
 * User-facing relative-date copy shared by the web and mobile clients.
 * Each function preserves the exact copy voice of the surface it came from;
 * agent-facing age ladders stay in recency.ts (compactAgeLabel, describeAge).
 */
import { compactAgeLabel } from "./recency.js";
const MS_PER_DAY = 86_400_000;
/** Local-time midnight for calendar-day arithmetic (not the UTC date-key math). */
export function startOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}
/** Completion-history voice: "Today", "Yesterday", "3 days ago", "Last week". */
export function formatRelativeDate(iso) {
    const date = new Date(iso);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffDays = Math.floor(diffMs / MS_PER_DAY);
    if (diffDays === 0)
        return "Today";
    if (diffDays === 1)
        return "Yesterday";
    if (diffDays < 7)
        return `${diffDays} days ago`;
    if (diffDays < 14)
        return "Last week";
    if (diffDays < 30)
        return `${Math.floor(diffDays / 7)} weeks ago`;
    if (diffDays < 60)
        return "Last month";
    return `${Math.floor(diffDays / 30)} months ago`;
}
const RELATIVE_DATE_FORMAT = new Intl.DateTimeFormat(undefined, {
    month: "short",
    day: "numeric",
});
/** Web feed voice: compact ladder under a week, absolute date beyond it. */
export function formatRelativeCompact(value) {
    const then = new Date(value);
    if (Date.now() - then.getTime() >= 7 * MS_PER_DAY)
        return RELATIVE_DATE_FORMAT.format(then);
    return compactAgeLabel(then.getTime(), Date.now());
}
/** Mobile feed voice: "Just now", "5m ago", "3h ago", "2d ago", then a date. */
export function formatRelativeCasual(value) {
    const date = new Date(value);
    if (Number.isNaN(date.getTime()))
        return "";
    const seconds = Math.max(0, Math.floor((Date.now() - date.getTime()) / 1000));
    if (seconds < 60)
        return "Just now";
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60)
        return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24)
        return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    if (days < 7)
        return `${days}d ago`;
    return date.toLocaleDateString([], { month: "short", day: "numeric" });
}
//# sourceMappingURL=relative-labels.js.map